import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ROUTES } from 'utils/routes';
import * as globalSelectors from 'store/global/selectors';
import { Col, Row } from 'react-bootstrap';
import { Widget } from '@spins/react-ui-library';
import ReactGA from 'react-ga';
import './styles.scss';
import { AuthSession, useAuthSession } from '@spins/react-sso-provider';

interface Props {
  clientId: string;
}

const Scorecards: React.FC<Props> = ({ clientId }) => {
  const authSession: AuthSession = useAuthSession();
  const containerRef: React.RefObject<HTMLIFrameElement> = React.createRef();

  const send = () => {
    const data = {
      username: authSession.user.email,
      displayName: `${authSession.user.firstName} ${authSession.user.lastName}`,
      destiniOrganization: { name: clientId }
    };
    containerRef.current.contentWindow.postMessage(JSON.stringify(data), '*');
  };

  useEffect(() => {
    ReactGA.pageview(ROUTES.SCORECARDS);
    containerRef.current.onload = () => {
      send();
    };
  });

  return (
    <Row className="mt-3">
      <Col>
        <Widget>
          {{
            header: {
              title: 'Scorecards'
            },
            body: {
              content: (
                <div className="scorecard-frame-container">
                  <iframe
                    className="scorecardFrame"
                    ref={containerRef}
                    src={process.env.REACT_APP_SCORECARDS_URL}
                    title="scorecards"
                  />
                </div>
              )
            }
          }}
        </Widget>
      </Col>
    </Row>
  );
};

const mapStateToProps = state => ({
  clientId: globalSelectors.clientIdSelector(state)
});

export default connect(mapStateToProps)(Scorecards);
